import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Home } from 'app/home/Home';
import { AppRoute } from 'routing/AppRoute.enum';
import { useIam } from 'api/hooks/useIam/useIam';
import { useAssets } from 'hooks/useAssets/useAssets';
import { useUser } from 'hooks/useUser/useUser';
import { UserRole } from 'context/user/userContext/UserContext.types';

const dashboardUser = {
  firstName: 'Bebat',
  lastName: 'Y',
  email: 'bats@madeinchina.com',
  origin: 'Belgium',
};

export const HomeDesktopContainer = () => {
  const { login, logout, getUserData } = useIam();
  const { push } = useHistory();
  const { setAssets } = useAssets();
  const { setUser, clearUserInfo } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation<{ redirect?: string } | undefined>();

  useEffect(() => {
    async function init() {
      setAssets(null);
      clearUserInfo();
      await logout();
    }
    init();
  }, []);

  const loginToAccount = async (key?: string) => {
    setIsLoading(true);
    const result = await login(key);
    if (result.connected) {
      const data = await getUserData();
      if (!data.role) {
        setUser({ ...dashboardUser, ...data, role: UserRole.GoverningBody });
        setIsLoading(false);
        push(state?.redirect ? state.redirect : AppRoute.dashboard);
      } else {
        await logout();
      }
    } else {
      setIsLoading(false);
      logout();
    }
  };

  const handleLogin = async () => {
    await loginToAccount();
  };

  const onLoginWithBebatRole = async () => {
    await loginToAccount(process.env.REACT_APP_BEBAT_KEY);
  };

  return (
    <Home
      onLogin={handleLogin}
      showRegister={false}
      isLoading={isLoading}
      onLoginWithBebatRole={onLoginWithBebatRole}
    />
  );
};
